/**
 * @todo - add type defs
 */
//@ts-nocheck
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createOcapiFetch } from './utils';
class OcapiShopperCustomObjects {
    constructor(config) {
        this.fetch = createOcapiFetch(config);
    }
    getOffsetDatePricing(...args) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.fetch('custom_objects/AlgoliaOffsetDates/pricing', 'GET', args, 'getOffsetDatesPricing');
        });
    }
}
export default OcapiShopperCustomObjects;
